import { configureStore } from '@reduxjs/toolkit'
import newsReducer from '../Components/NewsTicker/newsSlice';
import contactReducer from '../Components/contact/contactSlice';

export const store = configureStore({
    reducer: {
        news: newsReducer,
        contact: contactReducer
    }
})